import { Link } from "react-router-dom";
import { Container, SocialList, SliceBorder } from "../../../../shared/ui";

import { RoutesEnum } from "../../../../shared/constants/routes";
import { LogoThirtyYearsWhite } from "../../../../shared/assets/svg";
import { currentFullYear, generateMediaQuery } from "../../../../shared/lib/helpers";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";

import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";
import { VacancyOfferForm } from "../../../../entities/Vacancy";

import { FooterNav } from "../FooterNav";

import styles from "./Footer.module.scss";

export const Footer = () => {
    const isTablet = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.lg));
    const isMobile = useMediaQuery(`(max-width: 575px)`);
    const isMobileForm = useMediaQuery(`(max-width: 900px)`);

    return (
        <footer className={styles.footerWrapper}>
            <Container marginSize="standard">
                <div className={styles.footer}>
                    {!isMobile && (
                        <div className={styles.footer__columns}>
                            <div className={styles.footer__menu}>
                                {isMobileForm ? (
                                    <div className={styles.footer__menuLogo}>
                                        <Link to={RoutesEnum.Home}>
                                            <LogoThirtyYearsWhite className={styles.footer__logo} />
                                        </Link>
                                        <p>
                                            Нет вакансии? <VacancyOfferForm />. Возможно, она скоро появится.
                                        </p>
                                    </div>
                                ) : (
                                    <Link to={RoutesEnum.Home}>
                                        <LogoThirtyYearsWhite className={styles.footer__logo} />
                                    </Link>
                                )}

                                {!isTablet && <FooterNav />}

                                <SocialList className={styles.footer__socialList} />
                            </div>
                            {!isMobileForm && (
                                <div className={styles.footer__formMenu}>
                                    <div className={styles.footer__form}>
                                        <SliceBorder
                                            className={styles.footer__formWrapper}
                                            colorBackground="#ffffff00"
                                            sizeRadius={20}
                                            border={{
                                                topLeft: "outside-corner-lateral",
                                                bottomLeft: "inside-bottom-left",
                                            }}
                                        />
                                    </div>

                                    <div className={styles.footer__formCaption}>
                                        <p>
                                            Нет вакансии? <VacancyOfferForm />. Возможно, она скоро появится.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {isMobile && <SocialList className={styles.footer__socialListMobile} />}
                    <div className={styles.footer__disclaimer}>
                        <div>
                            <p>
                                «БКС Мир инвестиций» используется ООО «Компания БКС» (лицензия № 154-04434-100000 от 10.01.2001 на осуществление брокерской деятельности. Выдана ФСФР. Без ограничения срока действия) в качестве товарного знака. С информацией об ООО «Компания БКС» можно ознакомиться: bcs.ru/regulatory.
                            </p>
                        </div>
                        <div className={styles.footer__copyrights}>
                            <p>
                                &copy;&nbsp;1995&ndash;{currentFullYear()}&nbsp;ООО &laquo;Компания БКС&raquo;. Любое
                                использование материалов сайта без разрешения запрещено.
                            </p>
                        </div>
                    </div>
                </div>
            </Container>
        </footer>
    );
};
